import EyeHidden from '@olxeu-a2b/ui/src/commons/components/icons/EyeHidden';
import { Paragraph2, Paragraph3 } from '@nexus/lib-react/dist/core/Typography';
import { LinkParagraph } from '@nexus/lib-react/dist/core/Link/LinkParagraph';
import styled from '../../../../../../theme/styled';
import mq from '../../../../../../commons/styles/mediaQueries';

const Dac7ProfileWrapper = styled.div`
  background: #fff;
  display: flex;
  align-items: start;
  flex-direction: column;
  width: 100%;
  border-radius: 4px;
  margin: 0 auto;
  padding: 24px 16px;
  gap: 16px;
  ${mq.desktop} {
    gap: 24px;
    padding: 40px;
  }
`;

const Title = styled.div`
  font-size: 12px;
  color: #406367;
  display: flex;
  font-weight: 700;
`;

const SubTitle = styled(Paragraph2)`
  margin: 0;
  font-weight: bold;
`;

const Text = styled(Paragraph3)`
  font-weight: 400;
`;

const BoldText = styled(Text)`
  font-weight: 500;
`;

const StyledEyeHidden = styled(EyeHidden)`
  margin: 0 16px 0 4px;
`;

const StyledLinkParagraph = styled(LinkParagraph)`
  color: #000;
`;

const ButtonWrapper = styled.div`
  text-align: right;
  width: 100%;
`;

const GreenText = styled.span`
  color: #00a49f;
`;

const Button = styled.button`
  background-color: #ffffff;
  border: 2px solid #002f34;
  border-radius: 4px;
  color: #000;
  font-weight: 700;
  font-size: 16px;
  line-height: 18px;
  margin-top: 20px;
  justify-content: center;
  margin: 0;
  min-height: 40px;
  box-sizing: border-box;
  align-items: center;
  padding: 14px 32px;
  cursor: pointer;
  :hover {
    background-color: #002f34;
    color: #fff;
  }

  ${mq.mobileAndTablet} {
    width: 100%;
  }
`;

export {
  Dac7ProfileWrapper,
  ButtonWrapper,
  StyledLinkParagraph,
  Text,
  BoldText,
  SubTitle,
  Title,
  StyledEyeHidden as EyeHidden,
  Button,
  GreenText,
};
